<template lang="pug">
  div
    section.content-header
      h1 {{page_title}}

      ol.breadcrumb
        li
          //- システム管理のトップ画面に繋げる
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li
          router-link(:to="{name: 'extrigger'}") きっかけ管理
        li.active {{page_title}}

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      form(ref="form", @submit.prevent="postData", novalidate)
        mixin btnbar
          .bcard-btnbar(class!=attributes.class)
            button.btn.btn-primary(type="submit") {{action_name}}
            |
            |
            router-link.btn.btn-default(:to="{name: 'extrigger'}") キャンセル
            template(v-if="this.id")
              | &nbsp;
              .btn-separator
              | &nbsp;
              button.btn.btn-danger(type="button" @click.prevent="isModalConfOpen = true") 削除

        +btnbar

        .box.box-widget

          .box-body
            .form-group
              label.control-label(for="bcard-extrigger-edit-name") きっかけ名
                span.bcard-required (*)
              input#bcard-extrigger-edit-name.form-control(type="text" v-model="item.name", :maxlength="maxlengths.name" required)

            p.bcard-required ※ (*)は必須項目です。

        +btnbar.-bottom

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    app-modal(type="danger" v-model="isModalConfOpen")
      template(slot="title") きっかけ情報の削除
      h4 きっかけ情報を削除します。よろしいですか？
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-danger(type="button" @click="close(); delExtrigger();") 削除
        button.btn.btn-default(type="button" @click="close") キャンセル
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import mixinForm from '@/mixins/form'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const ExtriggerRepository = RepositoryFactory.get('extrigger')

export default {
  name: 'ExtriggerEdit',
  components: { AppModal, AppMessages },
  mixins: [ mixinForm ],
  props: {
    id: {
      type: [String, Number],
      required: false,
      default: 0
    },
    item: {
      type: Object,
      required: false,
      default: function () {
        return {
          name: ''
        }
      }
    }
  },
  data: function () {
    return {
      page_title: this.id ? 'きっかけ情報の変更' : 'きっかけ情報の作成',
      action_name: this.id ? '変更' : '作成',
      isModalConfOpen: false,
      maxlengths: {}
    }
  },
  created: function () {
    this.maxlengths = this.loadMaxlengths('Extriggers')
    // 変更時の初期データ
    if (this.id) {
      // API実行
      const vm = this
      ExtriggerRepository.get(this.id)
        .then(function (response) {
          const extrigger = vm.getApiData(response).data
          vm.item.name = extrigger.name
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    }
  },
  methods: {
    delExtrigger: function () {
      const vm = this

      // 削除API実行
      ExtriggerRepository.delete(this.id)

        // 成功時処理
        .then(function (response) {
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'extrigger'})
          }
        })

        // エラー時処理
        .catch(function (error) {
          vm.errors.push(vm.setErrorMessage(error))
        })
    },
    postData: function () {
      if (!this.checkFormValidity()) return

      const vm = this
      const params = {}
      let repos

      // 登録内容
      params.name = this.item.name

      // 更新オプション
      if (this.id) {
        repos = ExtriggerRepository.put(this.id, params)
      // 作成オプション
      }
      else {
        repos = ExtriggerRepository.post(params)
      }

      // API実行
      repos
        // 成功時処理
        .then(function (response) {
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'extrigger'})
          }
        })
        // システムエラー
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/extrigger/Edit.vue